// Remembers the partner (reseller) code from a link such as voip2.co.uk/?partner=fastpanda for 60 days, so a
// visitor who signs up later still counts for that partner.
const KEY = 'voip2_partner';
const DAYS = 60;
const CODE = /^[a-z0-9][a-z0-9-]{1,30}$/;

export const capturePartner = () => {
  try {
    const code = (new URLSearchParams(window.location.search).get('partner') || '').toLowerCase();
    if (CODE.test(code)) localStorage.setItem(KEY, JSON.stringify({ code, until: Date.now() + DAYS * 86400000 }));
  } catch (e) { /* storage blocked: the link still works on the signup page itself */ }
};

export const currentPartner = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || 'null');
    return v && v.until > Date.now() && CODE.test(v.code) ? v.code : null;
  } catch (e) { return null; }
};
